import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue";
import { useOrganizations } from "@/store/organizations";
import { useAuth } from "@/store/auth";
import { onMounted } from "vue";
import Filters from "./Comparison/filters.vue";
import Chart from "./Comparison/chart.vue";
import XAxis from "./Comparison/x-axis.vue";

import {
	filtersBase,
	filterOrganizations,
	xAxis,
	type Item,
	type SelectedFilters,
	type XAxisType,
} from "@/util/chart-utils"

type Emits = {
	(e: "moveToLogin"):void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'comparison-tool',
  emits: ["moveToLogin"],
  setup(__props, { expose: __expose, emit }) {
  __expose();



const auth = useAuth();
const organizations = useOrganizations();

const xAxisState = ref<XAxisType>(xAxis);
const orgsCountTotal = ref(0);
const showFilters = ref(true);
const showLocation = ref(false);
const selectedFilters = ref<SelectedFilters>({...filtersBase});

function handleColumnsSelection(e:Item){
	var idx = xAxisState.value.findIndex(x => {return (x.k === e.k)});
	xAxisState.value[idx].value = !e.value;
}

function handleFiltersChange(event: any){
	selectedFilters.value[event.key] = event.selected
}

function handleShowFilters(){
	showFilters.value = !showFilters.value;
}

function handleClearFilters( ){
	showLocation.value = false;
	showFilters.value = false;
	selectedFilters.value = {...filtersBase};
}

const filteredOrganizations = computed(() => {
	let filteredList = Object.values(organizations.organizations);
	filteredList = filterOrganizations(selectedFilters.value, filteredList);
	filteredList = filteredList.splice(0,5);
	orgsCountTotal.value = filteredList.length;
	return filteredList;
});

onMounted(async()=>{
	await organizations.waitForReady();
	await auth.waitForReady();
	if(auth.user === null){
		emit("moveToLogin")
	}
	orgsCountTotal.value = filteredOrganizations.value.length;
})


const __returned__ = { emit, auth, organizations, xAxisState, orgsCountTotal, showFilters, showLocation, selectedFilters, handleColumnsSelection, handleFiltersChange, handleShowFilters, handleClearFilters, filteredOrganizations, ref, computed, watch, get useOrganizations() { return useOrganizations }, get useAuth() { return useAuth }, onMounted, Filters, Chart, XAxis, get filtersBase() { return filtersBase }, get filterOrganizations() { return filterOrganizations }, get xAxis() { return xAxis } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})